export enum EmailTabEnum {
  ReservationReminder = "ReservationReminder",
  VisitingThanks = "VisitingThanks",
  HappyBirthday = "HappyBirthday",
}